import React from 'react';

const PageHeading = ({firstPart, secondPart}) =>
  <div className="page-heading">
    <h2><span>{firstPart.replace('Dakar Rally', 'Formel 2').replace('Moto3', 'Formel 3').replace('British Superbike', 'IMSA')}</span> {secondPart.replace('British Superbike', 'IMSA')}</h2>
  </div>;

PageHeading.propTypes = {
  firstPart: React.PropTypes.string,
  secondPart: React.PropTypes.string,
};

export default PageHeading;



// WEBPACK FOOTER //
// ./src/component/PageHeading.jsx